export type LocalFeatureFlags = Record<string, boolean>

type LocalFeatureFlagsModule = {
  default?: LocalFeatureFlags
  localFeatureFlags?: LocalFeatureFlags
}

const localFeatureFlagsModule = Object.values(
  import.meta.glob<LocalFeatureFlagsModule>('../localFeatureFlags.local.ts', { eager: true }),
)[0]

export const localFeatureFlags =
  localFeatureFlagsModule?.localFeatureFlags ?? localFeatureFlagsModule?.default ?? {}

export const hasLocalFeatureFlags = Object.keys(localFeatureFlags).length > 0
